const callbacks = new Map();

export const setRefreshCallback = (key, callback) => {
  if (callback) {
    callbacks.set(key, callback);
  } else {
    callbacks.delete(key);
  }
};

export const triggerRefresh = (key) => {
  const cb = callbacks.get(key);
  if (cb) cb();
};
